import React from 'react';
import PreviousStep from './previous';
import CurrentStep from './current';
import NextStep from './next';
import classNames from 'classnames';

export type Url = {
	link: string;
	label: string;
};

export interface PizzaTrackerProps {
	urls: Url[];
	current: number;
}

export const PizzaTracker = ({ urls, current }: PizzaTrackerProps) => {
  const selectStep = (selected: number, url: Url) => {
    if (selected < current) {
      return <PreviousStep url={url} />
    } else if (selected === current) {
      return <CurrentStep url={url} />
    } else {
      return <NextStep url={url} />
    }
  };
	return (
		<nav aria-label="Progress">
			<ol className="flex items-center">
				{urls.map((url: Url, key: number) => (
					<li
						key={url.link}
						className={classNames(
							key !== urls.length - 1 ? 'pr-16 md:pr-36' : '',
							'relative'
						)}>
						{selectStep(key, url)}
					</li>
				))}
			</ol>
		</nav>
	);
};
